module.exports = __webpack_public_path__ + "static/media/moscow.46aa3a72.jpg";